export default __webpack_public_path__ + "static/media/icn-verify-documents-on.993c9538.svg";